"use client";

import { RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";

type ClearButtonProps = {
  onClear: () => void;
  label?: string;
};

export function ClearButton({ onClear, label = "Clear" }: ClearButtonProps) {
  return (
    <Button type="button" variant="ghost" size="sm" onClick={onClear}>
      <RotateCcw className="h-4 w-4" />
      {label}
    </Button>
  );
}
